/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer[_ngcontent-%COMP%]{display:flex}.footer[_ngcontent-%COMP%]   .footer-total[_ngcontent-%COMP%]{flex:2}.footer[_ngcontent-%COMP%]   .footer-selecionados[_ngcontent-%COMP%]{text-align:right;flex:4}"];
export { styles as styles };
